import { render, staticRenderFns } from "./StandingAccountList.vue?vue&type=template&id=145d1bec&scoped=true"
import script from "./StandingAccountList.vue?vue&type=script&lang=js"
export * from "./StandingAccountList.vue?vue&type=script&lang=js"
import style0 from "./StandingAccountList.vue?vue&type=style&index=0&id=145d1bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d1bec",
  null
  
)

export default component.exports